export default {"src":"/_next/static/media/paragon-logo.a8172538.svg","height":192,"width":800,"blurWidth":0,"blurHeight":0};